
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import GAService from '@/services/ga.service';

@Component({
  components: {
  },
})
export default class DeleteProfileModal extends Vue {

  public deleteLoading: boolean = false;

  get profileToDelete() {
    return this.$store.state.profiles.profileToDelete;
  }

  public closeModal() {
    this.$store.commit('setModal', '');
  }

  public async deleteProfile() {
    this.deleteLoading = true;

    try {
      GAService.sendEvent(this.$gtag, 'Profile', 'Deleted', this.profileToDelete.name);
      await this.$store.dispatch('deleteProfile', this.profileToDelete);
      this.$store.commit('setToastSuccess', 'Profile deleted successfully.');
      this.closeModal();
      this.deleteLoading = false;
    } catch (e) {
      this.$store.commit('setToastError', 'Error deleting profile.');
      this.deleteLoading = false;
    }
  }
}

